import React, { useContext, useEffect, useState } from 'react';
import { Modal, message, Form, Input, Select } from 'antd';
import { Context } from '../../../defaults';
import { updateClasses } from '../../../actions';
import { MaskedInput } from 'antd-mask-input';
import { studyYearRegex } from '../../../common';

export function ClassesModal({ modalProps, teachers, closeModal }) {
  const { dictionary, language } = useContext(Context);
  const [currentClass, setCurrentClass] = useState({});
  const [teachersId, setTeachersId] = useState();
  const [studyYear, setStudyYear] = useState();
  const modalTitle = `${dictionary?.EditClass[language]}`;
  const requiredMessage = `${dictionary?.RequiredField[language]}`;

  useEffect(() => {
    setCurrentClass(modalProps.currentClass);
    if (modalProps.currentClass) {
      const teacher = teachers?.find((x) => x.classId === modalProps.currentClass?.id);
      setTeachersId(teacher?.id);
    }
  }, [modalProps.currentClass, teachers]);

  const onUpdateClass = () => {
    updateClasses(teachersId, currentClass)
      .then(() => {
        message.success(dictionary?.SuccessfullyChanged[language], { duration: 4 });
        closeModal();
      })
      .catch(() => {
        message.error(dictionary?.SomethingWentWrong[language], { duration: 4 });
        closeModal();
      });
  };

  function rulesForStudyYear(e) {
    if (!!e) {
      const value = e.target.value;
      const years = value.split('/');
      if (years[0] > years[1]) {
        return {
          validateStatus: 'error',
          help: 'Начало года обучения не может быть больше чем конец года обучения',
        };
      }
      if (
        Number.isInteger(parseInt(years[0])) &&
        Number.isInteger(parseInt(years[1])) &&
        years[1] - years[0] !== 1
      ) {
        return {
          validateStatus: 'error',
          help: 'Начало года обучения должно быть минимум 1 год ниже',
        };
      }
      if (!value.match(studyYearRegex)) {
        return { validateStatus: 'error', help: dictionary?.StudyYearField[language] };
      }
      if (!value) {
        return { validateStatus: 'error', help: requiredMessage };
      } else {
        return { validateStatus: 'success', help: null };
      }
    }
  }

  const onChange = ({ target }) => {
    const { name, value } = target;
    setCurrentClass({ ...currentClass, [name]: value });
  };

  return (
    <Modal
      title={modalTitle}
      visible={modalProps.visible}
      onOk={onUpdateClass}
      okButtonProps={{ disabled: !currentClass?.year || !currentClass?.letter }}
      onCancel={() => closeModal()}
      okText={dictionary?.Save[language]}
      cancelText={dictionary?.Cancel[language]}
      width={600}
      >
      <Form layout="horizontal" labelCol={{ span: 7 }} name="nest-messages">
        <Form.Item
          label={dictionary?.Year[language]}
          validateStatus={currentClass?.year ? 'success' : 'error'}
          help={currentClass?.year ? '' : requiredMessage}
          hasFeedback>
          <Input
            style={{ width: '385px' }}
            name="year"
            onChange={onChange}
            value={currentClass?.year}
          />
        </Form.Item>
        <Form.Item
          label={dictionary?.Letter[language]}
          validateStatus={currentClass?.letter ? 'success' : 'error'}
          help={currentClass?.letter ? '' : requiredMessage}
          hasFeedback>
          <Input
            style={{ width: '385px' }}
            name="letter"
            onChange={onChange}
            value={currentClass?.letter}
          />
        </Form.Item>
        <Form.Item
          label={dictionary?.YearStudy[language]}
          validateStatus={currentClass?.yearOfStudy ? 'success' : 'error'}
          help={currentClass?.yearOfStudy ? '' : requiredMessage}
          hasFeedback>
          <MaskedInput
            name="yearOfStudy"
            value={currentClass?.yearOfStudy}
            onChange={onChange}
            mask="11/11"
            placeholder="__/__"
            style={{ width: '385px' }}
          />
        </Form.Item>
        <Form.Item label={dictionary?.Teacher[language]}>
          <Select
            placeholder={dictionary?.Teacher[language]}
            name="teacherId"
            allowClear={true}
            value={teachersId}
            onChange={(value) => setTeachersId(value)}
            style={{ width: '385px' }}
            >
            {teachers &&
              teachers
                .filter((x) => x.classId === null || x.id === teachersId)
                .map((el) => {
                  return (
                    <Select.Option value={el.id} key={el.id}>
                      {`${el.lastName} ${el.firstName} ${el.middleName}`}
                    </Select.Option>
                  );
                })}
          </Select>
        </Form.Item>
      </Form>
    </Modal>
  );
}
